import type Specialty from "parog-web/models/specialty";

//---- Automatically generated, don't update this part ----
/**
 * Describes a performer
 */

interface Params {
  name: any;
  specialty: Specialty;
  organization: any;
}

export default class Performer {
  constructor(params: Params) {
    this.name = params.name;
    this.specialty = params.specialty;
    this.organization = params.organization;
  }

  toJson() {
    return {
      name: this.name,
      specialty: this.specialty,
      organization: this.organization
    };
  }

  name: any;

  specialty: Specialty;

  organization: any;

  //---- End of generated code ----
}
